import { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { EnvelopeOpen } from "react-bootstrap-icons";
import HeaderModal from "./HeaderModal/HeaderModal";
import { headerInfo } from "./headerInfo";
import app_params from "../../config/params";

export default function HeaderSection() {
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => {
    setShowModal(!showModal);
  };

  return (
    <div className="c-top-header-section">
      <Container>
        <div className="c-top-header-section-collection jaja">
          <div className="c-top-header-container">
            <div>
              <div className="c-top-header-title">
                <h1 onClick={handleShow}>Biblioteca de Ciencias Sociales</h1>
              </div>
              <div className="c-divisor">
                <div className="c-line"></div>
              </div>
            </div>
            <div className="c-top-header-collection-buttons">
              <Button onClick={handleShow} className="c-see-more">
                CONOZCA MAS DE BIBLIOTECA
              </Button>
              <a
                href={`${app_params.otherSite}contactenos`}
                className="c-contact"
              >
                <EnvelopeOpen />
              </a>
            </div>
            {/* </div> */}
          </div>
          <HeaderModal
            title={headerInfo?.title}
            description={headerInfo?.description}
            show={showModal}
            setShow={setShowModal}
            image={headerInfo?.image}
          />
        </div>
      </Container>
    </div>
  );
}
